import { registerMarkdownShortcuts } from "@lexical/markdown";
import { defineExtension, safeCast, type LexicalExtension } from "lexical";
import { isSafeUrl, type EditorPreset } from "../../index";
import { createTypingTransformers } from "./transformers";

export interface MarkdownShortcutsConfig {
  preset: EditorPreset;
  validateUrl: (url: string) => boolean;
}

/**
 * Typing shortcuts only. Upstream already skips updates made during IME composition and by
 * undo/redo, which is what keeps an undone conversion from instantly re-applying.
 */
export const MarkdownShortcutsExtension: LexicalExtension<
  MarkdownShortcutsConfig,
  "z-editor/markdown-shortcuts",
  unknown,
  unknown
> = defineExtension({
  name: "z-editor/markdown-shortcuts",
  config: safeCast<MarkdownShortcutsConfig>({
    preset: "document",
    validateUrl: (url) => isSafeUrl(url),
  }),
  register: (editor, config) =>
    registerMarkdownShortcuts(editor, createTypingTransformers(config.preset, config.validateUrl)),
});
